import React from "react";

const LosePage = () => {
    return (
        <div className="lose-page">
            <p className="lose-page__text-err">You lost!</p>
            <p className="lose-page__text">Refresh the page to try again</p>
        </div>
    );
};

export default LosePage;
